import { render, staticRenderFns } from "./ConfirmationEmailSettings.vue?vue&type=template&id=0ff6d60d"
import script from "./ConfirmationEmailSettings.vue?vue&type=script&lang=js"
export * from "./ConfirmationEmailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports